import { useCallback } from 'react';
import type { ReactionType } from '../domain';
import { NodeReaction } from '../domain';
import type { ModelId, NodeId, UserId, ViewModelId } from 'balus-common';
import { RefBuilder, ServerValue, usePersistedObject } from '@framework/repository';
import { RTDBPath } from 'balus-common';
import { toast } from 'react-hot-toast';
import { useTranslation } from 'react-i18next';

export const useNodeReaction = (
  viewModelId: ViewModelId,
  modelId: ModelId,
  nodeId: NodeId
): {
  reaction: NodeReaction | null | undefined;
  toggleReaction: (reactionName: ReactionType, userId: UserId, userName: string) => void;
} => {
  const { t } = useTranslation();
  const [reaction] = usePersistedObject(NodeReaction, RTDBPath.Node.reactionPath(viewModelId, modelId, nodeId));

  const toggleReaction = useCallback(
    (reactionType: ReactionType, userId: UserId, userName: string) => {
      const ref = RefBuilder.ref(RTDBPath.Node.reactionItemPath(viewModelId, modelId, nodeId, reactionType, userId));

      if (reaction && reaction.isReactionExecuted(reactionType, userId)) {
        ref.remove();
      } else {
        // 50件以上のreactionは保存しない
        if (reaction?.hasMaxReached(reactionType)) {
          toast.error(t('canvas.nodeReaction.error.limitReached'));
        } else {
          ref.set({ name: userName, timestamp: ServerValue.TIMESTAMP });
        }
      }
    },
    [modelId, nodeId, reaction, t, viewModelId]
  );

  return { reaction, toggleReaction };
};
